module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [(_vm.row.member_list) ? _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row,
      "label-width": "120px"
    }
  }, [_vm._l((_vm.row.member_list), function(member, index) {
    return _c('div', [_c('el-divider', [_vm._v("人员信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": '人员' + (index + 1)
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.memberRemove(member, index)
        }
      }
    }, [_vm._v("移除人员信息 "), _c('i', {
      staticClass: "el-icon-circle-close"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (member.name),
        expression: "member.name"
      }],
      staticClass: "form-label-desc"
    }, [_vm._v(_vm._s(member.name + '(' + member.num + ')'))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "性别",
        "prop": "sex"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.sex),
        callback: function($$v) {
          _vm.$set(member, "sex", $$v)
        },
        expression: "member.sex"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": '男'
      }
    }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": '女'
      }
    }, [_vm._v("女")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "微信号",
        "prop": 'member_list.' + index + '.weixin',
        "rules": [{
          required: true,
          message: '请输入微信号',
          trigger: 'blur'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入微信号"
      },
      model: {
        value: (member.weixin),
        callback: function($$v) {
          _vm.$set(member, "weixin", $$v)
        },
        expression: "member.weixin"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机",
        "prop": 'member_list.' + index + '.phone',
        "rules": [{
          required: true,
          message: '请输入正确的手机号',
          trigger: 'blur'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入手机号"
      },
      model: {
        value: (member.phone),
        callback: function($$v) {
          _vm.$set(member, "phone", $$v)
        },
        expression: "member.phone"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.row.gametype == 3),
        expression: "row.gametype == 3"
      }]
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "是否参加能力测试：",
        "rules": []
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "是",
        "inactive-text": "否",
        "active-color": "#409EFF",
        "inactive-color": "#ddd"
      },
      model: {
        value: (member.is_join_exame),
        callback: function($$v) {
          _vm.$set(member, "is_join_exame", $$v)
        },
        expression: "member.is_join_exame"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "技术等级测试项目：",
        "rules": []
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入技术等级测试项目"
      },
      model: {
        value: (member.join_exame_name),
        callback: function($$v) {
          _vm.$set(member, "join_exame_name", $$v)
        },
        expression: "member.join_exame_name"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-label-desc mt10"
    }, [_vm._v("技巧/花球/街舞/爵士")])], 1)], 1)], 1)], 1), _vm._v(" "), (false) ? _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "服务套餐"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (member.serviceName),
        callback: function($$v) {
          _vm.$set(member, "serviceName", $$v)
        },
        expression: "member.serviceName"
      }
    }, _vm._l((_vm.row.member_list[index].service_options), function(item) {
      return _c('el-radio', {
        attrs: {
          "label": item.name
        }
      }, [_vm._v(_vm._s(item.name) + "\n                ")])
    }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', _vm._l((_vm.row.extra_field), function(field, fileindex) {
      return _c('el-col', {
        key: fileindex,
        attrs: {
          "span": 12
        }
      }, [_c('el-form-item', {
        attrs: {
          "label": field.label,
          "prop": 'member_list.' + index + '.jsondata.' + field.label,
          "rules": [{
            required: field.required,
            message: '请输入' + field.label
          }]
        }
      }, [_c('el-input', {
        attrs: {
          "type": "text",
          "placeholder": '请输入' + field.label
        },
        model: {
          value: (member.jsondata[field.label]),
          callback: function($$v) {
            _vm.$set(member.jsondata, field.label, $$v)
          },
          expression: "member.jsondata[field.label]"
        }
      }), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (field.desc),
          expression: "field.desc"
        }],
        staticClass: "form-label-desc mt10"
      }, [_vm._v(_vm._s(field.desc))])], 1)], 1)
    }), 1)], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "normal",
      "round": "",
      "icon": "plus"
    },
    on: {
      "click": _vm.onMemberAdd
    }
  }, [_vm._v("新增人员\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.addShow) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm mt10",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.formData.cardtype == 1) ? _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "num",
      "rules": [{
        required: true,
        message: '请输入身份证号',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "证件号码",
      "prop": "huzhao",
      "rules": [{
        required: true,
        message: '请输入证件号码',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.formData.huzhao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "huzhao", $$v)
      },
      expression: "formData.huzhao"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件类型",
      "prop": "cardtype"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.cardtype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cardtype", $$v)
      },
      expression: "formData.cardtype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("身份证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("护照")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm2('ruleForm2')
      }
    }
  }, [_vm._v("确定\n          ")])], 1)], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aeef149","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/songpei/SongpeiApplyFormStep1.vue
// module id = 1309
// module chunks = 0